import {
    Button,
    useAppDisplayModeContext,
    useStyles,
    pxToRem,
} from '@archipro-design/aria';
import { CustomArrowRight } from '@archipro-design/icons';
import * as S from './GetStartedButton.style';
interface GetStartedButtonProps {
    onClick?: () => void;
}

const GetStartedButton = ({ onClick }: GetStartedButtonProps) => {
    const { css } = useStyles();
    const { mobile } = useAppDisplayModeContext();
    return (
        <Button
            color="dark"
            size={14}
            variables={{
                buttonPadding: 16,
                iconPadding: 4,
                buttonSize14TextFontSize: pxToRem(mobile ? 13 : 14),
            }}
            onClick={onClick}
            iconAfter={mobile ? <CustomArrowRight /> : undefined}
            className={css(S.GetStartedBtn)}
        >
            GET STARTED
        </Button>
    );
};

export default GetStartedButton;
